export enum ErrorCodes {
  UNKNOWN_ERROR_CODE = 1,
  INVENTORY_CHECK_FAILED = 3001,
  PRODUCT_ACCESS_ERROR = 3002,
  INVALID_SAP = 1006,
  DOA_EXCEED_LIMIT = 4011,
  CREDIT_CARD_PAYMENT_ERROR_CODE = 4013,
  CREDIT_CARD_AMOUNT_EXCEEDED_ERROR_CODE = 4014,
}
